/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Research_BodyInputs */

const en_services_svc_research_body = /** @type {(inputs: Services_Svc_Research_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agents that gather, compare and check information across the web and your own records, then hand back a brief where every claim links to where it came from.`)
};

const lv_services_svc_research_body = /** @type {(inputs: Services_Svc_Research_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aģenti, kas savāc, salīdzina un pārbauda informāciju no interneta un Jūsu ierakstiem un nodod kopsavilkumu, kurā katrs apgalvojums norāda uz savu avotu.`)
};

/**
* | output |
* | --- |
* | "Agents that gather, compare and check information across the web and your own records, then hand back a brief where every claim links to where it came from." |
*
* @param {Services_Svc_Research_BodyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_research_body = /** @type {((inputs?: Services_Svc_Research_BodyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Research_BodyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_research_body(inputs)
	return en_services_svc_research_body(inputs)
});